import { chartInk } from '../../design-system/tokens';
import './CompletenessBar.css';

export interface CompletenessBarProps {
  /** Share of cells that carry a value, 0–100. */
  percentage: number;
  label?: string;
}

/**
 * How much of a dataset is filled in.
 *
 * Two parts of one whole, so the missing share is drawn as absence — a muted
 * neutral — rather than as a second category competing for attention. The
 * number is written out beside it: the bar is never the only way to read it.
 */
export function CompletenessBar({ percentage, label = 'Complete' }: CompletenessBarProps) {
  const filled = Math.max(0, Math.min(100, percentage));

  return (
    <div className="sc-completeness">
      <div className="sc-completeness__head">
        <span>{label}</span>
        <strong className="sc-numeric">{filled.toFixed(1)}%</strong>
      </div>
      <div
        className="sc-completeness__track"
        role="meter"
        aria-valuenow={Math.round(filled)}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`${label}: ${filled.toFixed(1)} percent of cells have a value`}
      >
        <div
          className="sc-completeness__fill"
          style={{ width: `${filled}%`, background: chartInk.series }}
        />
      </div>
    </div>
  );
}
